import API_tickets_search from "./tickets_search";
import API_change_tariff from "./change_tariff";
import API_get_variants from "./get_variants";

export const TicketsSearch = API_tickets_search;
export const ChangeTariff = API_change_tariff;
export const GetVariants = API_get_variants;

